import algoliasearch from "algoliasearch/lite";

export default function useProps(props) {
    const { container } = props

    return  {
        address: {
            lat: container.getAttribute('data-address-lat'),
            lng: container.getAttribute('data-address-lng'),
            text: container.getAttribute('data-address-text')
        },
        algolia: {
            client: algoliasearch(container.getAttribute('data-algolia-app-id'), container.getAttribute('data-algolia-secret')),
            prefix: container.getAttribute('data-algolia-prefix')
        },
        mapbox: {
            token: container.getAttribute('data-mapbox-token')
        },
        options: {
            radius: container.getAttribute('data-radius'),
            zoom: container.getAttribute('data-zoom'),
            markers: {
                color: container.getAttribute('data-marker-color')
            },
            show: {
                filters: container.getAttribute('data-filters'),
                areas: container.getAttribute('data-areas'),
                coordinatedExercise: container.getAttribute('data-coordinated-exercise'),
            },
            urls: {
                specialityDom: container.getAttribute('data-speciality-dom-url'),
                createAnnounce: container.getAttribute('data-create-announce-url')
            },
            isRegion: container.getAttribute('data-is-region'),
            isCountry: container.getAttribute('data-is-country'),
            createAnnounceButton: container.getAttribute('data-create-announce-button')
        },
        filters: {
            announceIds: container.getAttribute('data-announce-ids'),
            announceTypes: JSON.parse(container.getAttribute('data-announce-types')),
            speciality: container.getAttribute('data-speciality'),
            specialities: container.getAttribute('data-specialities'),
            user: container.getAttribute('data-user'),
            users: JSON.parse(container.getAttribute('data-users')),
            states: JSON.parse(container.getAttribute('data-states')),
            attributes: {
                types: JSON.parse(container.getAttribute('data-attribute-types')),
                filters: JSON.parse(container.getAttribute('data-attribute-filters')),
                skills: JSON.parse(container.getAttribute('data-attribute-skills')),
                structures: JSON.parse(container.getAttribute('data-attribute-structures')),
                relief: JSON.parse(container.getAttribute('data-attribute-relief')),
                density: JSON.parse(container.getAttribute('data-attribute-density')),
                areas: JSON.parse(container.getAttribute('data-attribute-areas')),
                coordinatedExercise: JSON.parse(container.getAttribute('data-attribute-coordinated-exercise')),
            }
        }
    }
}